export default function generateUniqueBrowserId() {
  let browserId = localStorage.getItem('deviceId');
  if (!browserId) {
    browserId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      c => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      },
    );
    localStorage.setItem('deviceId', browserId);
  }
  return browserId;
}
